import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent } from '@shared/button/button.component';
import { DrawingTools } from '@shared/drawing/drawing';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';

@Component({
  selector: 'zbp-viewer-zoom',
  imports: [
    NgbTooltip,
    ButtonComponent
  ],
  templateUrl: './viewer-zoom.component.html',
  styleUrl: './viewer-zoom.component.scss'
})
export class ViewerZoomComponent implements OnInit {
  zoomLevel = 100;
  zoomInActive: boolean = false;
  zoomOutActive: boolean = false;
  statusMessage: string = '';
  @Input() enabled: boolean = false;
  @Input() zoomMin: number = 100;
  @Input() zoomMax: number = 300;
  @Input() zoomIncrement: number = 50;
  @Output() activeZoomTool: EventEmitter<DrawingTools> = new EventEmitter();
  @Output() zoomPercent: EventEmitter<number> = new EventEmitter();
  tooltipText = 'Zoom is not available for this item.';

  protected readonly zbpIconNames = zbpIconNames;

  ngOnInit() {
    if (this.enabled) {
      this.tooltipText = '';
    }
  }

  handleZoomIn(): void {
    this.zoomInActive = true;

    if (this.zoomLevel < this.zoomMax) {
      this.zoomLevel += this.zoomIncrement;
    }

    this.zoomInActive = false;
    this.setZoomStatusMessage('in');
    this.zoomPercent.emit(this.zoomLevel);
    this.activeZoomTool.emit(DrawingTools.zoomIn);
  }

  handleZoomOut(): void {
    this.zoomOutActive = true;

    if (this.zoomLevel > this.zoomMin) {
      this.zoomLevel -= this.zoomIncrement;
    }

    this.zoomOutActive = false;

    this.setZoomStatusMessage('out');
    this.zoomPercent.emit(this.zoomLevel);
    this.activeZoomTool.emit(DrawingTools.zoomOut);
  }

  private setZoomStatusMessage(direction: 'in' | 'out'): void {
    this.statusMessage = `Zoomed ${direction} to ${this.zoomLevel} percent.`;
  }
}
